export const POPUP_WIDTH = 370;
export const POPUP_HEIGHT_PERCENT = 0.8;
